import { LabelContainer, MandatoryLabel } from './MandatoryFieldLabel.styles';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const MandatoryFieldLabel = (props: Props) => {
  return (
    <LabelContainer>
      {props.children}
      <MandatoryLabel>(Required)</MandatoryLabel>
    </LabelContainer>
  );
};
